import { defineComponent as r, computed as l, openBlock as s, createElementBlock as a, createElementVNode as t, toDisplayString as d, createCommentVNode as m, normalizeStyle as n, createStaticVNode as f } from "vue";
const p = ["viewBox"], z = /* @__PURE__ */ t("mask", { id: "42be4171-43fe-4841-9eb2-c0c49d811fd5" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), _ = { mask: "url(#42be4171-43fe-4841-9eb2-c0c49d811fd5)" }, v = { key: 0 }, u = /* @__PURE__ */ f('<path fill="#d80027" d="m0 178 254.2-22L512 178v22.3l-40.2 54.1 40.2 57.3V334l-254 23.4L0 334v-22.3l36.7-59.4-36.7-52z"></path><path fill="#338af3" d="M0 0h512v178H0z"></path><path fill="#eee" d="M0 200.3h512v111.4H0z"></path><path fill="#6da544" d="M0 334h512v178H0z"></path><path fill="#eee" d="M117.2 105.7a50 50 0 0 1 39.3-48.9 50.2 50.2 0 0 0-10.7-1.1 50 50 0 1 0 10.7 99c-22.5-5-39.3-25-39.3-49zm69 22.8 3.3 10.4h11l-9 6.5 3.5 10.4-9-6.4-8.7 6.4 3.4-10.4-9-6.5h11zm35 0 3.4 10.4h11l-9 6.5 3.4 10.4-8.8-6.4-9 6.4 3.5-10.4-9-6.5h11zm35 0 3.4 10.4h11l-9 6.5 3.5 10.4-9-6.4-8.8 6.4 3.4-10.4-9-6.5h11zm35 0 3.4 10.4h11l-9 6.5 3.5 10.4-9-6.4-8.8 6.4 3.4-10.4-9-6.5h11zm35 0 3.4 10.4h11l-9 6.5 3.5 10.4-9-6.4-8.8 6.4 3.4-10.4-8.8-6.5h11zm-105-36.4 3.4 10.4h11l-9 6.5 3.4 10.4-8.8-6.5-9 6.5 3.5-10.4-9-6.5h11zm35 0 3.4 10.4h11l-9 6.5 3.5 10.4-9-6.5-8.8 6.5 3.4-10.4-9-6.5h11zm35 0 3.4 10.4h11l-9 6.5 3.5 10.4-9-6.5-8.8 6.5 3.4-10.4-9-6.5h11zm35 0 3.4 10.4h11l-9 6.5 3.5 10.4-9-6.5-8.8 6.5 3.4-10.4-8.8-6.5h11zm-70-36.4 3.4 10.4h11l-9 6.4 3.6 10.5-9-6.5-8.8 6.5 3.4-10.5-9-6.4h11zm35 0 3.4 10.4h11l-9 6.4 3.6 10.5-9-6.5-8.8 6.5 3.4-10.5-9-6.4h11zm35 0 3.4 10.4h11l-9 6.4 3.6 10.5-9-6.5-8.8 6.5 3.4-10.5-8.8-6.4h11z"></path>', 5), k = { fill: "none" }, g = ["r"], N = /* @__PURE__ */ r({
  __name: "uz",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const e = c, o = l(() => 512 + 2 * e.strokeWidth), h = l(() => -e.strokeWidth), i = l(() => 256 + e.strokeWidth / 2);
    return (x, w) => (s(), a("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${h.value} ${h.value} ${o.value} ${o.value}`
    }, [
      z,
      t("g", _, [
        e.flagName ? (s(), a("title", v, d(e.flagName), 1)) : m("", !0),
        u
      ]),
      t("g", k, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: i.value,
          fill: "none",
          style: n({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, g)
      ])
    ], 8, p));
  }
});
export {
  N as default
};
//# sourceMappingURL=uz-90fad9f9.js.map
